import { SelectChangeEvent } from '@mui/material';
import type { DynamicLineItemPeriod } from '@vy/dynamic-invoice-builder';
import type { UsagePricingModel } from '@vy/types';
import { useCallback, useEffect, useMemo, useState } from 'react';

export const useUsagePeriodSelection = (periods: DynamicLineItemPeriod<UsagePricingModel>[]) => {
  const [selectedPeriodIndex, setSelectedPeriodIndex] = useState(0);

  useEffect(() => {
    if (periods.length > 0 && selectedPeriodIndex >= periods.length) {
      setSelectedPeriodIndex(0);
    }
  }, [periods, selectedPeriodIndex]);

  const handlePeriodChange = useCallback((event: SelectChangeEvent<number>) => {
    setSelectedPeriodIndex(Number(event.target.value));
  }, []);

  const currentPeriod = useMemo(() => {
    return periods[selectedPeriodIndex];
  }, [periods, selectedPeriodIndex]);

  return {
    selectedPeriodIndex,
    handlePeriodChange,
    currentPeriod,
  };
};
